module.exports = __webpack_public_path__ + "img/bell-circle.cfb8083.svg";